import { Component, input, effect, ChangeDetectionStrategy } from '@angular/core';
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DashboardVariables } from '../../../dashboard/dashboard.model';
import Utils from '../../../core/utils/utils';
import { Is } from '../../../core/utils/is';

@Component({
  selector: 'app-markdown-viewer',
  templateUrl: './markdown-viewer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './markdown-viewer.component.scss',
})
export class MarkdownViewerComponent {
  text = input<string>();
  fontSize = input<number>();
  variables = input<DashboardVariables[]>();
  sanitizedHtml: SafeHtml = '';

  constructor(private sanitizer: DomSanitizer) {
    effect(() => {
      let text = this.text() || '';
      if (this.variables()) {
        text = Utils.findVariablesAndReplace(text, match => {
          const newText = Utils.replaceVariableWithData(match, this.variables());
          if (Is.array(newText)) {
            return newText.join(', ');
          }
          return newText;
        });
      }
      const markedHtml = marked.parse(text);
      const sanitizedHtml = DOMPurify.sanitize(markedHtml as string);
      this.sanitizedHtml = this.sanitizer.bypassSecurityTrustHtml(sanitizedHtml);
    });
  }
}
